(function (Drupal, $, once) {
  const init = () => {
    // init Freeze Table
    const freezeTables = document.querySelectorAll('.js-freeze-table');
    if (!freezeTables.length) return;

    freezeTables.forEach((table) => {
      const frozenRows = +table.dataset.frozenRows;
      const frozenColumns = +table.dataset.frozenColumns;

      if (!frozenRows && !frozenColumns) return;

      if (window.matchMedia('(min-width: 760px)').matches) {
        $(table).freezeTable({
          freezeHead: frozenRows > 0,
          freezeColumn: frozenColumns > 0,
          columnNum: frozenColumns > 0 ? frozenColumns : 0
        });
      }
    });
  };

  once('table-wrap', $("table")).forEach(function (element) {
    var $this = $(element);
    if (!$this.parent().hasClass("table-wrap")) {
      $this.wrap(
        "<div class='table-grand-wrap'><div class='table-wrap'></div></div></div>"
      );
    }
    else {
      $this.parent().wrap("<div class='table-grand-wrap'></div>");
    }
    var wrapper = $this.parent();
    var grandWrapper = wrapper.parent(".table-grand-wrap");

    function adjustBlur() {
      var $width = wrapper.outerWidth();
      var $scrollWidth = wrapper[0].scrollWidth;
      var $scrollLeft = wrapper.scrollLeft();
      var $offset = 10;
      var ltr;

      if ($("html[dir='ltr']").length && $("main.main-content__wrapper:not([lang='ar'])").length) {
        ltr = true;
      }

      if (ltr) {
        $scrollWidth - $width > $scrollLeft + $offset
        ? grandWrapper.addClass("scrollable-right")
        : grandWrapper.removeClass("scrollable-right");
        $scrollLeft < $offset
        ? grandWrapper.removeClass("scrollable-left")
        : grandWrapper.addClass("scrollable-left");
      } else {
        $scrollWidth - $width > -($scrollLeft) + $offset
          ? grandWrapper.addClass("scrollable-left")
          : grandWrapper.removeClass("scrollable-left");
        -($scrollLeft) < $offset
          ? grandWrapper.removeClass("scrollable-right")
          : grandWrapper.addClass("scrollable-right");
      }
    }

    adjustBlur();

    $(window).resize(function () {
      adjustBlur();
    });

    $(wrapper).scroll(function () {
      adjustBlur();
    });
  });

  window.addEventListener('load', init);
})(Drupal, jQuery, once);
